import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import german from './phrase/german.json'
import french from './phrase/french.json'
import italian from './phrase/italian.json'

i18next
	.use(initReactI18next)
	.init({
		lng: 'German',
		debug: false,
		fallbackLng: process.env.NODE_ENV === 'production' ? 'German' : null,
		resources: {
			German: { translation: german, locale: 'de' },
			French: { translation: french, locale: 'fr' },
			Italian: { translation: italian, locale: 'it' }
		},
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		}
	})
